import HomeIcon from '@mui/icons-material/Home';

import {
  CardContainer,
  ReportTypeChip,
  SeeFullReportCTA,
  ViewReportButton,
} from '../../components';
import { formatPropertyAddress, hasValue } from '../utils';

import {
  HeaderAddressBlock,
  HeaderAddressMobile,
  HeaderGroup,
  HeaderLocationLine,
  HeaderRow,
  HeaderTitle,
  HeaderTitleDesktop,
} from './components';
import {
  CurrentOwnersSection,
  DetailsSection,
  RecordsHistorySection,
} from './sections';

import type { PropertyReportData } from 'components/DeepSearch/types';

interface PropertyReportPreviewCardProps {
  data: PropertyReportData;
  onViewReport?: () => void;
  onSendMessage?: (content: string, displayContent?: string) => void;
}

export const PropertyReportPreviewCard = ({
  data,
  onViewReport,
  onSendMessage,
}: PropertyReportPreviewCardProps) => {
  const hasPropertyType = hasValue(data.propertyType);
  const { streetLine, locationLine } = formatPropertyAddress(data);

  return (
    <CardContainer>
      <HeaderGroup>
        <HeaderRow>
          <HomeIcon sx={{ fontSize: 24, marginTop: '2px' }} />
          <HeaderAddressBlock>
            <HeaderTitleDesktop>
              {data.address || 'Property Report'}
            </HeaderTitleDesktop>
            <HeaderAddressMobile>
              <HeaderTitle>{streetLine || 'Property Report'}</HeaderTitle>
            </HeaderAddressMobile>
          </HeaderAddressBlock>
          {onViewReport && <ViewReportButton onClick={onViewReport} />}
        </HeaderRow>

        {locationLine && (
          <HeaderLocationLine>{locationLine}</HeaderLocationLine>
        )}
      </HeaderGroup>

      {hasPropertyType && <ReportTypeChip>{data.propertyType}</ReportTypeChip>}

      <DetailsSection data={data} />
      <CurrentOwnersSection data={data} onSendMessage={onSendMessage} />
      <RecordsHistorySection data={data} onSendMessage={onSendMessage} />
      {onViewReport && <SeeFullReportCTA onClick={onViewReport} />}
    </CardContainer>
  );
};
